<template>
  <!-- 通报批评新增情况 -->
  <div class="situation">
    <div class="accident">
      <div class="tip">受处理类型</div>
      <div class="drop_down" @click="showQuarter">
        <span v-if="!selectQuarter.text">请选择</span>
        <span class="selected" v-if="selectQuarter.text">{{selectQuarter.text}}</span>
        <img src="@/assets/appraise/arrow_right.png" alt />
      </div>
    </div>
    <div class="accident">
      <div class="tip">受处理时间</div>
      <div class="drop_down" @click="showTime">
        <span v-if="!selectTime.value">请选择</span>
        <span v-if="selectTime.value" class="selected">{{selectTime.name}}</span>
        <img src="@/assets/appraise/arrow_right.png" alt />
      </div>
    </div>
    <div class="link">
      <div class="link_title">受处理内容</div>
      <div class="content">
        <div class="about_content">
            <textarea class="content" placeholder="请输⼊受处理内容" maxlength="500" v-model="dealContent"></textarea>
        </div>
      </div>
    </div>
    <div class="upload_file">
      <div class="upload_tit">相关材料</div>
      <div class="file_item" v-for="item in fileResVOS" :key="item.id">
        <div class="file_msg">
          <img v-if="item.fileType ==='exl'" src="@/assets/appraise/ic_exl.png" alt />
          <img v-if="item.fileType ==='doc'" src="@/assets/appraise/ic_doc.png" alt />
          <img v-if="item.fileType ==='pdf'" src="@/assets/appraise/ic_pdf.png" alt />
          <p class="file_name">
            <span>{{item.fileName}}.{{item.fileType}}</span>
          </p>
        </div>
        <!-- <div class="file_size">{{item.fileSize}}</div> -->
        <div class="delImg" @click="del(item)">
          <img src="@/assets/appraise/delete.png" alt />
        </div>
      </div>
      <addBtn ref="resetfileadd" v-if="fileResVOS.length<10" :isShowSpan="true" :isGoAndroidandIOS="true" :needEmit="true" @fields="getFiles"></addBtn>
    </div>
    <div class="btns">
      <van-button @click="save" type="primary" size="large">保存</van-button>
    </div>
    <titleDialog
      v-if="showDialog"
      :title="dialogTitle"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></titleDialog>
    <commonPicker
      ref="commonPickerQuarter"
      :typeList="newQuarterList"
      :title="title"
      :cols="cols1"
      @getTypeValue="getTypeValue"
    ></commonPicker>
    <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
    <tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips=false"></tipDialog>
  </div>
</template>

<script>
import titleDialog from "../components/titleDialog.vue";
import commonPicker from "../../../components/base/myCommonPicker.vue";
import timePick from "../../../components/base/timePick.vue";
import addBtn from "../appraiseNew/components/addBtn.vue";
import tipDialog from "../travelNegative/components/tipDialog.vue";
import api from "@/service/modules/appraiseNew.js";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
export default {
  components: {
    titleDialog,
    commonPicker,
    timePick,
    addBtn,
    tipDialog
  },
  data() {
    return {
      showTips: false,
      showDialog: false,
      requireCont: '',
      dialogTitle: '',
      cancelBtn: '',
      confirmBtn: '',
      isSave: '1',  // 点击的是删除还是保存按钮 1删除2保存
      delItem: {},
      dealContent: '',
      selectTime: {},
      selectQuarter: {},
      fileResVOS: [],
      // newQuarterList: [
      //   [
      //     { id: "E1", text: "受到通报批评" },
      //     { id: "E2", text: "受到约谈问责" },
      //     { id: "E3", text: "涉旅企业警告、整改、取消等级" }
      //   ]
      // ],
      newQuarterList:[],
      cols1: 1,
      title: "",
      //权限字段
      accidentListAuth: this.$route.query.accidentListAuth,
      meetListAuth: this.$route.query.meetListAuth,
      abarbeitungListAuth: this.$route.query.abarbeitungListAuth
    };
  },
  created() {
    // 通过权限控制 用户可新增 那些 子项模块的数据
    // console.log('----这里没东西？', this.accidentListAuth);
    const initNotify = [
      { id: "E1", text: "受到通报批评" },
      { id: "E2", text: "受到约谈问责" },
      { id: "E3", text: "涉旅企业警告、整改、取消等级" }
    ];
    let temArr = [];
    for (let i = 0; i < initNotify.length; i++) {
      if (initNotify[i].id === this.accidentListAuth) {
        temArr.push(initNotify[i]);
      }
      if (initNotify[i].id === this.meetListAuth) {
        temArr.push(initNotify[i]);
      }
      if (initNotify[i].id === this.abarbeitungListAuth) {
        temArr.push(initNotify[i]);
      }
    }
    this.newQuarterList.push( temArr)
    this.initData();
  },
  methods: {
    // 初始化
    initData() {
      if (this.$route.query.id) {
        this.queryDetail();
      }
    },
    // 获取详情内容
    queryDetail() {
      let params = {
        id: this.$route.query.id
      };
      api.getNoticeDetail(params).then(res => {
        console.log('-----详情内容：', res);
        if (res.ret === 0) {
          this.dealContent = res.data.punishDesc;
          this.fileResVOS = res.data.fileResVOS;
          this.fileResVOS.forEach(item => {
            item.fileKindCN = "";
            item.showType = "";
          });
          console.log('----类型:',  this.newQuarterList[0]);
          this.selectQuarter = this.newQuarterList[0].filter(item => {
            return item.id === res.data.punishType;
          })[0];
          this.selectTime = {
            name:
              res.data.punishTime.split("-")[0] +
              "年" +
              res.data.punishTime.split("-")[1] +
              "月" +
              res.data.punishTime.split("-")[2] +
              "日",
            value: res.data.punishTime
          };
        }
      });
    },
    // 删除附件
    del(item) {
      this.dialogTitle = "是否确定删除附件";
      this.cancelBtn = "取消";
      this.confirmBtn = "删除";
      this.isSave = '1';
      this.delItem = item;
      this.showDialog = true;
      this.$refs.resetfileadd.resetFile();
    },
    // 上传附件回调
    getFiles(file) {
      console.log('---返回的文件回调:', file);
      this.fileResVOS.push(file[0]);
    },
    // 保存
    save() {
      if (!this.selectQuarter.id) {
        this.showTips = true;
        this.requireCont = "请选择“受处理类型”";
        return;
      } else if (!this.selectTime.value) {
        this.showTips = true;
        this.requireCont = "请选择“受处理时间”";
        return;
      } else if (this.dealContent === "") {
        this.showTips = true;
        this.requireCont = "请填写“受处理内容”";
        return;
      } else if (this.fileResVOS.length === 0) {
        this.showTips = true;
        this.requireCont = "请上传“相关附件”";
        return;
      }
      this.isSave = '2';  // 点击的是删除还是保存按钮 1删除2保存
      this.dialogTitle = '是否确定保存';
      this.cancelBtn = '取消';
      this.confirmBtn = '保存';
      this.showDialog = true;
    },
    // 弹窗确认回调
    confirm() {
      if(this.isSave  === '1') {
        let index = this.fileResVOS.indexOf(this.delItem);
        this.fileResVOS.splice(index, 1);
        this.showDialog = false;
        this.$toast('删除成功');
      }else {
        this.saveNotification();
        this.showDialog = false;
      }
    },
    // 新增
    saveNotification() {
      const { area, year, quarter } = this.$route.query;
      let params = {
        id: this.$route.query.id,
        punishDesc: this.dealContent,
        punishTime: this.selectTime.value,
        punishType: this.selectQuarter.id,
        fileResVOS: this.fileResVOS,
        area,
        quarter,
        year,
      }
      api.leaderNoticeCreate(params).then(res => {
        if(res.ret === 0) {
          this.$Toast({
            message: this.$route.query.id ? '更新成功' : '新增成功',
            icon
          })
          setTimeout(()=>{
            // this.$router.replace(`/appraise/notificationList?area=${area}&year=${year}&quarter=${quarter}`)
            this.$router.back(-1);
          },2000)
        }
      });
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    },
    showQuarter() {
      // 唤起类型选择组件
      this.$refs.commonPickerQuarter.showPicker();
    },
    // 受处理类型回调
    getTypeValue(value) {
      this.selectQuarter = value[0];
    },
    showTime() {
      this.$refs.timePick.showPicker();
    },
    getTimeValue(val) {
      this.selectTime = {
        name:
          val.split("-")[0] +
          "年" +
          val.split("-")[1] +
          "月" +
          val.split("-")[2] +
          "日",
        value: val
      };
    }
  }
};
</script>

<style scoped lang="less">
.situation {
  padding: 9px 12px 0;
}
.accident {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  height: 46px;
  border-bottom: 1px solid #ededed;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .input input {
    text-align: right;
  }
  .input input::-webkit-input-placeholder {
    font-size: 14px;
    color: #ccc;
    text-align: right;
  }
  .drop_down {
    span {
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    img {
      display: inline-block;
      width: 12px;
      height: 12px;
      vertical-align: text-top;
    }
    span.selected {
      color: #333;
      font-size: 14px;
    }
  }
}
.link {
  .link_title {
    padding: 16px 0 12px;
    font-size: 14px;
    color: #666;
  }
  .content {
    .van-field {
      width: 351px;
      height: 120px;
      padding: 16px 12px 28px 12px;
      overflow: auto;
      background-color: #f5f5f5;
    }
     /deep/ .van-field__body {
      padding: 2px 0 0 0;
      margin-top: -2px;
    }
   
  }
}
.btns {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 12px;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
  .van-button {
    width: 351px;
    height: 40px;
    background-color: #36b374;
  }
}
.upload_file {
  padding-bottom: 60px;
  background-color: #fff;
  .upload_tit {
    padding: 16px 0;
    font-size: 14px;
    color: #666;
  }
}
.file_item {
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  .file_msg {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .file_msg img {
    margin-right: 12px;
    width: 34px;
    height: 38px;
  }
  .file_msg p {
    font-size: 14px;
    color: #333;
    span {
      line-height: 20px;
      word-break: break-word;
    }
  }
  .file_size {
    font-size: 12px;
    color: #999;
  }
  .delImg {
    box-sizing: border-box;
    line-height: 38px;
    margin-left: 5px;
    margin-right: 10px;
  }
  .delImg img {
    width: 15px;
    height: 16px;
  }
}
.about_content{
     width:100%;
     position: relative;
     .content{
       width:100%;
       height:120px;
       font-size:14px;
       color:#323233;
       background-color: #f5f5f5;
       border:0;
       outline: none;
       border-radius: 3px;
       padding:16px;
       box-sizing: border-box;
       line-height: 1.3em;
    }
  }
</style>